import { render, staticRenderFns } from "./PlayerLogs.vue?vue&type=template&id=b8ac8b9e&scoped=true&"
import script from "./PlayerLogs.vue?vue&type=script&lang=js&"
export * from "./PlayerLogs.vue?vue&type=script&lang=js&"
import style0 from "./PlayerLogs.vue?vue&type=style&index=0&id=b8ac8b9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ac8b9e",
  null
  
)

export default component.exports